module.exports = __webpack_public_path__ + "media/tph/favicon-da389e83.ico";